const Song = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-base sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl'>
        <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-2xl sm:text-4xl sm:pb-5 md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl'>Bài Ca Hướng Đạo Việt Nam</h1>
        <p className='text-slate-300 pt-5 leading-tight'>
          Nâng cao lá cờ Hướng Đạo nhuộm oai hùng,<br />
          Sáng ngời. Ta cùng đi, cùng xây đời mới.<br />
          Vui tươi hát ca đi trên con đường lạ,<br />
          chúng ta nguyện thẳng tiến xông pha.
        </p>
        <p className='text-pink-200 pt-5 leading-tight'>
          Anh em ơi ! Rèn cánh tay Sẵn Sàng<br />
          Anh em ơi ! Rèn trái tim vững vàng<br />
          Tiếng kêu gọi , xin ai chớ quên !
        </p>
        <p className='text-slate-300 pt-5 leading-tight'>
          Anh em ơi ! Kìa Nước non đang chờ.<br />
          Anh em ơi ! Đại Nghĩa luôn tôn thờ.<br />
          Chúng ta nguyện kiên tâm tiến lên.
        </p>
        <p className='text-yellow-100 pt-5 leading-tight'>
          Hướng Đạo Việt Nam đuốc thiêng soi đường.<br />
          Hướng Đạo Việt Nam khó khăn coi thường.<br />
          Luôn luôn ta bền gan, rèn Tâm hồn trong sáng.<br />
          Dâng cho Nước non nhà muôn lời điểm tô.<br />
          Cho Xã hội rạng ngời. Chúng ta một lời.
        </p>
      </div>
    </div>
  )
}

export default Song
